module.exports = __webpack_public_path__ + "static/media/home-hero--foreground-gradient.cf712f06.png";